import { Box, Checkbox, FormControlLabel, Grid, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import AHMIS, { API_URL } from '../../../api/api'
import AddAlertMessage from '../../../components/alert/Alert'
import CustomReactSelect from '../../../components/custom-react-select/CustomReactSelect'
import DeleteRegisterRecordConformation from '../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation'
import CustomModal from '../../../components/modal/CustomModal'
import MulDartaaSelect from '../../../components/mul-dartaa-select/MulDartaaSelect'
import PendingPatientList from '../../../components/pending-patient-list/PendingPatientList'
import RegisterHeader from '../../../components/register-header/RegisterHeader'
import { AppMisc } from '../../../misc/appMisc'
import { ERROR, NCD, REQUIRED_FIELD, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants'
import { DISEASE, ICD_CODE_OPTIONS, IMPROVEMENT_STATUS, MUL_DARTA_NUMBERS_LIST, TREATMENT_STATUS } from '../../../utils/constants/forms'
import { DateUtils } from '../../../utils/dateUtils'
import { SessionStorage } from '../../../utils/storage/sessionStorage'
import NcdRegister from '../../users/components/register/Ncd-register/NcdRegister'

const NcdForm = () => {
  const [modalTitle, setModalTitle] = useState("नसर्ने रोग तथा मानसिक स्वास्थ्य सेवा रजिष्टर नयाँ रेकर्ड थप्नुहोस्।");
  const [showNcdModal, setShowNcdModal] = useState(false)
  const [getTableData, setGetTableData] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [ncdDataTable, setNcdDataTable] = useState([]);
  const [totalSize, setTotalSize] = useState();
  const [showNcdDeleteModal, setShowNcdDeleteModal] = useState(false);
  const [ncdDeleteId, setNcdDeleteId] = useState(null);
  const districtOptions = AppMisc.getDistrictOptions();
  const [page, setPage] = useState(0);
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch, control } = useForm();
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const [pendingPatientList, setPendingPatientList] = useState([])

  const openNcdModal = () => {
    setShowNcdModal(true);
  }

  const closeNcdModal = () => {
    reset({
      icdCode: "",
      disease: "",
      diagnosisTest: "",
      possibleDiagnosis: "",
      medicine: "",
      mentalConsultation: "",
      paramarsa: "",
      others: "",
      treatmentStatus: "",
      improvementStatus: "",
      sewaType: "",
      referredIn: "",
      referredOut: "",
      patientFirstName: "",
      patientLastName: "",
      age: "",
      wardNumber: "",
      phoneNumber: "",
      nid: "",
      gaunOrTole: "",
    });
    setShowNcdModal(false);
    setModalDefaultValues()
  }

  useEffect(() => {
    register("dead")
    register("treatmentStatus")
    register("improvementStatus")
    register("icdCode");
    register("disease", { required: true })
  }, [register])

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  }

  const handlePalikaNameChange = (name, value) => {
    setValue(name, value);
  }

  const submitNcdForm = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    AHMIS.post(API_URL.nonCommunicable, data)
      .then((response) => {
        if (response.data.type === "success") {
          closeNcdModal()
          setGetTableData(true)
          ncdPendingPatient()
          getNcdData(fromDate, toDate)
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message })
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const ncdEdit = (id) => {
    AHMIS.get(API_URL.nonCommunicable + "/" + id)
      .then((response) => {
        const data = response?.data?.data;
        data.icdCode = AppMisc.getLabelFromValues(ICD_CODE_OPTIONS, data.icdCode);
        setModalDefaultValues(data);
        setShowNcdModal(true);
        if (data) {
          Object.keys(data).forEach((key) => setValue(key, data[key]));
        }
      })
      .catch(() => AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG }));
  };

  const closeNcdDeleteModal = () => {
    setShowNcdDeleteModal(false);
    setNcdDeleteId(null);
  }

  const onDeleteNcdRow = (id) => {
    setShowNcdDeleteModal(true);
    setNcdDeleteId(id);
  }

  const deleteNcdPatientRow = (data) => {
    AHMIS.delete(API_URL.nonCommunicable + "/" + ncdDeleteId + "?deletedReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowNcdDeleteModal(false);
          setNcdDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          setGetTableData(true);
          getNcdData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const handleCustomReactSelectChange = (name, value) => {
    if (name === "icdCode") {
      const selectedValue = ICD_CODE_OPTIONS
        .flatMap((type) => type.options)
        .find((option) => option.label === value)?.value || value;

      setValue(name, selectedValue);
    } else {
      setValue(name, value);
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
    setGetTableData(true);
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getNcdData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams])

  const getNcdData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.nonCommunicable}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(page) + 1)}&rowSize=${ROW_PER_PAGE}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setNcdDataTable(jsondata?.data?.objectList || []);
        setGetTableData(false);
        setTotalSize(jsondata?.data?.size)
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    setPage(0)
    getNcdData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=12&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
  }, [])

  useEffect(() => {
    ncdPendingPatient()
  }, [])

  const ncdPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"12"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${NCD}`
    AHMIS.get(url).then((response) => {
      let jsondata = response.data;
      setPendingPatientList(jsondata.data)
    })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="नसर्ने रोग तथा मानसिक स्वास्थ्य सेवा रजिष्टर"
          handleModalOpen={openNcdModal}
          onHeaderParamChange={onHeaderParamChange}
          getRegisterData={getNcdData}
          getTableData={getTableData}
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showNcdModal}
        onModalSubmit={handleSubmit(submitNcdForm)}
        onModalClose={closeNcdModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            handleSelectedDartaaMitiChange={handleDateChange}
            registerConstant={NCD}
          />
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6">General Examination</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="ICD Code"
                name="icdCode"
                onChange={handleCustomReactSelectChange}
                options={ICD_CODE_OPTIONS}
                defaultValue={modalDefaultValues?.icdCode}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="रोग"
                name="disease"
                onChange={handleCustomReactSelectChange}
                options={DISEASE}
                defaultValue={modalDefaultValues?.disease}
              />
              {errors?.disease && errors.disease?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="निदानात्मक परीक्षण"
                size="small"
                variant="outlined"
                name="diagnosisTest"
                fullWidth
                defaultValue={modalDefaultValues?.diagnosisTest}
                {...register("diagnosisTest")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="सम्भावित निदान"
                size="small"
                variant="outlined"
                name="possibleDiagnosis"
                fullWidth
                defaultValue={modalDefaultValues?.possibleDiagnosis}
                {...register("possibleDiagnosis")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="औषधि"
                size="small"
                variant="outlined"
                name="medicine"
                fullWidth
                defaultValue={modalDefaultValues?.medicine}
                {...register("medicine")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="मनोसामाजिक परामर्श"
                size="small"
                variant="outlined"
                name="mentalConsultation"
                fullWidth
                defaultValue={modalDefaultValues?.mentalConsultation}
                {...register("mentalConsultation")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="परामर्श"
                size="small"
                variant="outlined"
                name="paramarsa"
                fullWidth
                defaultValue={modalDefaultValues?.paramarsa}
                {...register("paramarsa")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="अन्य"
                size="small"
                variant="outlined"
                name="others"
                fullWidth
                defaultValue={modalDefaultValues?.others}
                {...register("others")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="उपचार नियमितता"
                name="treatmentStatus"
                onChange={handleCustomReactSelectChange}
                options={TREATMENT_STATUS}
                defaultValue={modalDefaultValues?.treatmentStatus}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="उपचार नियमितता"
                name="improvementStatus"
                onChange={handleCustomReactSelectChange}
                options={IMPROVEMENT_STATUS}
                defaultValue={modalDefaultValues?.improvementStatus}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="सेवाको प्रकार"
                size="small"
                variant="outlined"
                name="sewaType"
                fullWidth
                defaultValue={modalDefaultValues?.sewaType}
                {...register("sewaType")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई आएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredIn"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredIn}
                fullWidth
                {...register("referredIn")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई गएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredOut"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredOut}
                fullWidth
                {...register("referredOut")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <Tooltip title="मृत्यु भएको चिन्ह लगाउनुहोस ।" placement="top" arrow>
                <Controller
                  name="died"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      label="मृत्यु भएको"
                      control={
                        <Checkbox {...field} checked={field.value} color="primary" />
                      }
                    />
                  )}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      </CustomModal>
      {
        pendingPatientList.size > 0 &&
        <Box mt={2}>
          <PendingPatientList
            pendingPatientList={pendingPatientList}
            showModal={setShowNcdModal}
            modalDefaultValues={setModalDefaultValues}
            setValue={setValue}
          />
        </Box>
      }
      <DeleteRegisterRecordConformation
        showDeleteModal={showNcdDeleteModal}
        closeDeleteModel={closeNcdDeleteModal}
        deleteRecord={deleteNcdPatientRow}
      />
      <NcdRegister
        onEditRow={ncdEdit}
        tableData={ncdDataTable}
        deleteRow={onDeleteNcdRow}
        handleChangePage={handleChangePage}
        page={page}
        totalSize={totalSize}
        getTableData={(value) => setGetTableData(value)}
      />
    </>
  )
}

export default NcdForm;